import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParticipantStatuses } from 'hooks';
import { CameraIcon, MicrophoneIcon, PersonIcon, MicrophoneDisabledIcon, CameraDisabledIcon } from 'components/elements/Icons';
import { NameLabel } from 'components/elements';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function ChatParticipants({ classes, expectedParticipants, isWaitingRoom, accountId }) {
  const styles = useStyles();
  const wrapperClasses = cn(styles.participants, classes);
  const { t } = useTranslation('labels');
  const { participantsVideoStatuses, participantsAudioStatuses, participantsJoinStatuses } = useParticipantStatuses();
  return (
    <div className={wrapperClasses}>
      <Typography sx={{ fontWeight: 'bold' }} variant="h6" component="h6" noWrap>
        {`${t('participants')} (${expectedParticipants.length})`}
      </Typography>
      <div className={styles.participantsWrapper}>
        {expectedParticipants?.map((participant) => {
          const isLocalParticipant = accountId === participant.id;
          const isParticipantJoined = participant.callStatus || participantsJoinStatuses.includes(participant.id);
          return (
            <div className={styles.participant} key={participant.id}>
              <div className={cn(styles.extendedParticipantInfoWrapper, { [styles.participantInfoWrapper]: !isWaitingRoom })}>
                <PersonIcon classes={cn(styles.participantIcon, { [styles.disabledParticipantIcon]: !isLocalParticipant && !isParticipantJoined })} />
                <Typography className={styles.participantName} variant="body1" component="span" noWrap>
                  <NameLabel fullName={participant.name} personalPronoun={participant.personalPronoun} options={{ pronoun: { parentheses: true, mutedText: true } }} />
                </Typography>
                <Typography variant="body1" component="span">
                  {isLocalParticipant ? `(${t('you')})` : ''}
                </Typography>
              </div>

              {(isLocalParticipant || isParticipantJoined) && !isWaitingRoom ? (
                <div className={styles.participantControls}>
                  <div className={styles.controlIconWrap}>
                    {!participantsAudioStatuses.includes(participant.id) ? (
                      <MicrophoneDisabledIcon classes={styles.controlIcon} />
                    ) : (
                      <MicrophoneIcon classes={styles.controlIcon} />
                    )}
                  </div>
                  <div className={styles.controlIconWrap}>
                    {!participantsVideoStatuses.includes(participant.id) ? <CameraDisabledIcon classes={styles.controlIcon} /> : <CameraIcon classes={styles.controlIcon} />}
                  </div>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}

ChatParticipants.propTypes = {
  classes: PropTypes.string,
  expectedParticipants: PropTypes.arrayOf(PropTypes.object),
  isWaitingRoom: PropTypes.bool,
  accountId: PropTypes.string,
};

ChatParticipants.defaultProps = {
  classes: '',
  expectedParticipants: [],
  isWaitingRoom: false,
  accountId: '',
};

export default ChatParticipants;
